const uid = () => Math.random().toString(36).slice(2, 9)

export const NUMERIC_OPERATORS = [
  { value: 'gt',  label: '>' },
  { value: 'gte', label: '≥' },
  { value: 'lt',  label: '<' },
  { value: 'lte', label: '≤' },
  { value: 'eq',  label: '=' },
  { value: 'neq', label: '≠' },
]

export const STRING_OPERATORS = [
  { value: 'eq',         label: '=' },
  { value: 'neq',        label: '≠' },
  { value: 'contains',   label: 'contains' },
  { value: 'notContains',label: 'excludes' },
]

export function getOperatorsForType(colType) {
  return colType === 'number' || colType === 'date'
    ? NUMERIC_OPERATORS
    : STRING_OPERATORS
}

export function makeCondition(column = '', dataTypes = {}) {
  const type = dataTypes[column] ?? 'string'
  const ops = getOperatorsForType(type)
  return { id: uid(), column, operator: ops[0].value, value: '' }
}

export function makeTopN(column = '') {
  return { column, n: 10, direction: 'desc' }
}

function testCondition(cellValue, operator, value) {
  const numVal = Number(value)
  switch (operator) {
    case 'gt':          return Number(cellValue) > numVal
    case 'gte':         return Number(cellValue) >= numVal
    case 'lt':          return Number(cellValue) < numVal
    case 'lte':         return Number(cellValue) <= numVal
    case 'eq':          return String(cellValue) === String(value)
    case 'neq':         return String(cellValue) !== String(value)
    case 'contains':    return String(cellValue).toLowerCase().includes(String(value).toLowerCase())
    case 'notContains': return !String(cellValue).toLowerCase().includes(String(value).toLowerCase())
    default:            return true
  }
}

export function applyFilters(data, filters) {
  if (!data || !filters) return data
  const { conditions = [], topN = null } = filters

  const active = conditions.filter(c => c.column && c.operator && c.value !== '')
  const hasTopN = topN && topN.column && topN.n > 0

  if (!active.length && !hasTopN) return data

  let dataset = data.dataset

  for (const cond of active) {
    dataset = dataset.filter(row => testCondition(row[cond.column], cond.operator, cond.value))
  }

  if (hasTopN) {
    const { column, n, direction } = topN
    dataset = [...dataset]
      .sort((a, b) => {
        const av = a[column], bv = b[column]
        if (av == null) return 1
        if (bv == null) return -1
        return direction === 'desc'
          ? av > bv ? -1 : av < bv ? 1 : 0
          : av < bv ? -1 : av > bv ? 1 : 0
      })
      .slice(0, n)
  }

  // Build an index map once so we can recover original row positions in O(n).
  // The filtered rows are the same object references as in data.dataset, so
  // identity comparison is reliable.
  const indexMap = new Map(data.dataset.map((row, i) => [row, i]))
  const survivingIndices = dataset.map(row => indexMap.get(row))

  return { ...data, dataset, survivingIndices }
}

export function filtersAreActive({ conditions = [], topN = null } = {}) {
  return conditions.some(c => c.column && c.operator && c.value !== '') ||
    (topN != null && topN.column && topN.n > 0)
}

export const EMPTY_FILTERS = { conditions: [], topN: null }
